/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { Button__next } from "components/button/button";

/**
 * styled components
 */

const Container = styled.div`
  position: relative;
  ${t.mixins.flex({ justify: "flex-end" })}
  height: 64px;
  padding: 0 44px;
  background-color: ${t.color.tertiary};
  cursor: pointer;

  &:before {
    content: "";
    position: absolute;
    left: 1px;
    top: 0;
    background-image: url("${t.image.wave}");
    width: 422px;
    height: 25px;

    ${t.mixins.sm(`
      transform: scaleX(0.3);
      transform-origin: left;
    `)}
  }
`;
/**
 * submit component is..
 */

const Form__submit = ({ onSubmit, onError, title, filled }) => {
  const handleSubmit = () => {
    if (filled && onSubmit) {
      onSubmit();
    } else {
      onError();
    }
  };
  return (
    <Container onClick={handleSubmit}>
      <Button__next title={title} disabled={!filled} />
    </Container>
  );
};

export default Form__submit;

Form__submit.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Form__submit.defaultProps = {
  style: {},
};

/*
    import Form__submit from 'components/form/submit/form__submit'
    <Form__submit />
  */
